import './header.css'
import Icon from '@mdi/react';
import { mdiCartOutline, mdiExitToApp, mdiHandCoin, mdiMapSearch, mdiViewDashboard, mdiMenu, mdiClose } from '@mdi/js';
import logo_v1 from '../../../assets/logo_vetor_v1.png'
import logo_all_white from '../../../assets/logo_vetor_v1_all_white.png'
import { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../global';

export default function Header({isAuth, setIsAuth}) {

    const getData = async()=>{
      const response = await fetch(`${API_BASE_URL}/dados-usuario/get_user_data.php`, {
          method: "POST",
          headers: {
              "Content-Type": "application/json"
          },
          credentials: "include",
      });
  
      const data = await response.json();
      if (data.status === 'success') {
          setUserData(data.dados_basicos)
      }else{
          console.log(data.msg)
      }
    }

    useEffect(()=>{
        getData();
        const handleUpdate = () => getData();
        window.addEventListener('atualizarCreditos', handleUpdate);
        return () => window.removeEventListener('atualizarCreditos', handleUpdate);
    },[])

    const [userData, setUserData] = useState([]);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const navigate = useNavigate();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const irParaPrecos = () => {
      navigate("/", { state: { scrollToPlanos: true } });
    };


    const logout = async () => {
      const response = await fetch(`${API_BASE_URL}/auth/logout.php`, {
          method: "POST",
          headers: {
              "Content-Type": "application/json"
          },
          credentials: "include",
      });
  
      const data = await response.json();
      if(data.status === 'success'){
        navigate('/');
        localStorage.setItem('auth', "false");
        localStorage.removeItem('verificado');
        window.location.reload();
      }else{
        alert("Erro no logout. Tente novamente.")
      }
    }


  return (
        <div className="header_header-base">
            <div className="header_logo-container">
                <img className='header-logo' src={logo_all_white} alt="Me Localiza Logo" />
            </div>

            {/* Desktop Navigation */}
            <nav className="header_desktop-nav">
                <Link to='/'>Início</Link>
                <Link to='/Sobre'>Sobre</Link>
                <button onClick={irParaPrecos}>Adquira relatórios</button>
                <Link to='/FaleConosco'>Fale Conosco</Link>
            </nav>

            <div className="header_desktop-access">
                {isAuth && <p className='saldo-info'><Icon path={mdiHandCoin} size={1} /> {userData.creditos} créditos</p>}
                {!isAuth ? (
                    <div className="header_header-auth">
                        <Link to='/Autenticacao'>Entrar</Link>
                        <Link to='/Cadastro'>Cadastrar</Link>
                    </div>
                ) : (
                    <div className="header_header-auth">
                        <Link to='/Painel' style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
                            <Icon path={mdiViewDashboard} size={0.9} color={'#FF6F33'} />Painel
                        </Link>
                        <button onClick={() => { logout() }} className='button-logout' style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
                            <Icon path={mdiExitToApp} size={0.9} color={'#FFF'} />Sair
                        </button>
                    </div>
                )}
            </div>

            {/* Mobile Controls (Mobile only) */}
            <div className="header_mobile-controls">
                {isAuth && <p className='saldo-info'><Icon path={mdiHandCoin} size={1} /> {userData.creditos} créditos</p>}
                <button className="menu-toggle-btn" onClick={toggleMenu} aria-label="Toggle menu">
                    <Icon path={isMenuOpen ? mdiClose : mdiMenu} size={1.2} color={'#fff'} />
                </button>
            </div>

            {/* Mobile Dropdown Menu */}
            <div className={`header_mobile-menu ${isMenuOpen ? 'open' : ''}`}>
                <nav>
                    <Link to='/' onClick={closeMenu}>Início</Link>
                    <Link to='/Sobre' onClick={closeMenu}>Sobre</Link>
                    <button onClick={() => { irParaPrecos(); closeMenu(); }}>Adquira relatórios</button>
                    <Link to='/FaleConosco' onClick={closeMenu}>Fale Conosco</Link>
                </nav>
                <div className="header_mobile-auth">
                    {!isAuth ? (
                        <>
                            <Link to='/Autenticacao' className="login-btn-mobile" onClick={closeMenu}>Entrar</Link>
                            <Link to='/Cadastro' className="register-btn-mobile" onClick={closeMenu}>Cadastrar</Link>
                        </>
                    ) : (
                        <>
                            <Link to='/Painel' className="panel-btn-mobile" onClick={closeMenu}>
                                <Icon path={mdiViewDashboard} size={0.9} color={'#FF6F33'} />Painel
                            </Link>
                            <button onClick={() => { logout(); closeMenu(); }} className="logout-btn-mobile">
                                <Icon path={mdiExitToApp} size={0.9} color={'#FFF'} />Sair
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

